/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketing_Footer_ProductInputs */

const en_marketing_footer_product = /** @type {(inputs: Marketing_Footer_ProductInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Product`)
};

const es_marketing_footer_product = /** @type {(inputs: Marketing_Footer_ProductInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Producto`)
};

const fr_marketing_footer_product = /** @type {(inputs: Marketing_Footer_ProductInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Produit`)
};

/**
* | output |
* | --- |
* | "Product" |
*
* @param {Marketing_Footer_ProductInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" }} options
* @returns {LocalizedString}
*/
export const marketing_footer_product = /** @type {((inputs?: Marketing_Footer_ProductInputs, options?: { locale?: "en" | "es" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketing_Footer_ProductInputs, { locale?: "en" | "es" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_marketing_footer_product(inputs)
	if (locale === "es") return es_marketing_footer_product(inputs)
	return fr_marketing_footer_product(inputs)
});